module.exports = __webpack_public_path__ + "assets/envelope-24-px.da17ea1b.svg";